/* ===========================================================
   Preet Liquor — storefront behaviors
   (hero slideshow · interactive shelf · add-to-cart · reveals)
   =========================================================== */

/* ---------- Hero slideshow ---------- */
(function () {
  const slides = document.querySelectorAll('.hero-slide');
  const dots   = document.querySelectorAll('.hero-dot');
  if (!slides.length) return;
  let cur = 0, timer;
  function goTo(n) {
    slides[cur].classList.remove('active');
    if (dots[cur]) dots[cur].classList.remove('active');
    cur = (n + slides.length) % slides.length;
    slides[cur].classList.add('active');
    if (dots[cur]) dots[cur].classList.add('active');
  }
  timer = setInterval(() => goTo(cur + 1), 5500);
  dots.forEach(d => d.addEventListener('click', () => {
    clearInterval(timer);
    goTo(parseInt(d.dataset.slide));
    timer = setInterval(() => goTo(cur + 1), 5500);
  }));
})();

/* ---------- Add to cart (Shopify AJAX Cart API) ---------- */
async function preetAddToCart(variantId, qty) {
  qty = qty || 1;
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
  });
  if (!res.ok) throw new Error('add-to-cart failed');
  // update any cart-count bubbles
  try {
    const cart = await (await fetch('/cart.js')).json();
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.zero = cart.item_count === 0 ? 'true' : 'false'; });
  } catch (e) {}
  // open the theme cart drawer if one exists (Dawn-style)
  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.open === 'function') drawer.open();
  return res;
}

/* ---------- Interactive "What's on the Shelf" (product-driven) ---------- */
(function () {
  const track = document.getElementById('shfTrack');
  if (!track) return;
  const dataEl = document.querySelector('[data-shelf-products]');
  let SHELF = [];
  try { SHELF = JSON.parse(dataEl.textContent) || []; } catch (e) { SHELF = []; }
  if (!SHELF.length) return;

  const toast = document.getElementById('shfToast'); let tT;
  function showToast(name) {
    if (!toast) return;
    toast.innerHTML = '<b>' + name + '</b> added to cart';
    toast.classList.add('show');
    clearTimeout(tT); tT = setTimeout(() => toast.classList.remove('show'), 2200);
  }

  const pop    = document.getElementById('shfPop'),
        card   = document.getElementById('shfCard'),
        ptr    = document.getElementById('shfPtr'),
        wrap   = document.querySelector('.shf-wrap'),
        scroll = document.getElementById('shfScroll');
  let slots = [], active = null, down = false, sx = 0, sl = 0;

  function statusBadge(b) {
    if (b.available === false) return '<span class="shf-stk low">Sold Out</span>';
    if (b.inventory != null && b.inventory > 0 && b.inventory <= 6) return '<span class="shf-stk low">Few Left</span>';
    return '<span class="shf-stk in">In Stock</span>';
  }
  function cardHTML(b) {
    return '<div class="shf-eye">' + (b.type || '') + '</div>'
      + '<div class="shf-name">' + b.title + '</div>'
      + (b.note ? '<div class="shf-note">' + b.note + '</div>' : '')
      + (b.meta ? '<div class="shf-meta">' + b.meta + '</div>' : '')
      + '<div class="shf-row2"><span class="shf-price">' + b.price + '</span>' + statusBadge(b) + '</div>'
      + '<button class="shf-cart" type="button"' + (b.available === false ? ' disabled' : '') + '>'
      + (b.available === false ? 'Sold Out' : 'Add to Cart') + '</button>';
  }
  function place(slot) {
    const wr = wrap.getBoundingClientRect();
    const br = slot.querySelector('.shf-bottle').getBoundingClientRect();
    const pw = pop.offsetWidth, ph = pop.offsetHeight, pad = 8;
    const bx = br.left + br.width / 2 - wr.left, bty = br.top - wr.top;
    const left = Math.max(pad, Math.min(bx - pw / 2, wr.width - pw - pad));
    const top  = Math.max(pad, bty - ph - 15);
    pop.style.left = left + 'px';
    pop.style.top  = top + 'px';
    ptr.style.left = Math.max(16, Math.min(bx - left, pw - 16)) + 'px';
  }
  function openPop(slot) {
    const b = SHELF[+slot.dataset.i];
    if (active !== slot) {
      slots.forEach(s => s.classList.remove('is-active'));
      slot.classList.add('is-active'); track.classList.add('dimming'); active = slot;
      card.innerHTML = cardHTML(b);
      const btn = card.querySelector('.shf-cart');
      if (b.available !== false && btn) {
        btn.addEventListener('click', async function (e) {
          e.stopPropagation();
          if (btn.classList.contains('added')) return;
          btn.classList.add('added'); btn.textContent = 'Adding…';
          try { await preetAddToCart(b.variantId); btn.textContent = 'Added ✓'; showToast(b.title); }
          catch (err) { btn.textContent = 'Try again'; }
          setTimeout(() => { btn.classList.remove('added'); btn.textContent = 'Add to Cart'; }, 1700);
        });
      }
    }
    pop.classList.add('is-on'); place(slot);
  }
  function closePop() {
    pop.classList.remove('is-on'); track.classList.remove('dimming');
    if (active) { active.classList.remove('is-active', 'is-open'); active = null; }
  }

  SHELF.forEach(function (b, i) {
    const slot = document.createElement('div');
    slot.className = 'shf-slot'; slot.dataset.i = i;
    slot.style.cssText = '--glow:' + (b.glow || '#C8832A') + ';--bw:' + (b.bw || 84) + 'px';
    const img = b.image ? '<img class="shf-photo" src="' + b.image + '" alt="' + (b.title || '') + '" draggable="false">' : '';
    slot.innerHTML = '<div class="shf-bottle">' + img + '</div><div class="shf-base"></div>';
    track.appendChild(slot); slots.push(slot);
    slot.addEventListener('click', function () {
      if (track.dataset.dragged === '1') return;
      const pinned = slot.classList.contains('is-open');
      slots.forEach(s => s.classList.remove('is-open'));
      if (pinned) { closePop(); } else { slot.classList.add('is-open'); openPop(slot); }
    });
  });

  // plank paints in front of the bottles so they sit behind the shelf's front edge
  const plk = track.querySelector('.shf-plank'); if (plk) track.appendChild(plk);

  track.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'touch' || down) return;
    const bot = e.target.closest && e.target.closest('.shf-bottle');
    if (bot && bot.parentNode !== active) openPop(bot.parentNode);
  });
  wrap.addEventListener('pointerleave', function (e) {
    if (e.pointerType === 'touch') return;
    if (!(active && active.classList.contains('is-open'))) closePop();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.shf-slot') && !e.target.closest('.shf-pop')) closePop();
  });

  const aL = document.getElementById('shfL'), aR = document.getElementById('shfR');
  function step() { return Math.max(240, scroll.clientWidth * 0.7); }
  if (aL) aL.addEventListener('click', () => scroll.scrollBy({ left: -step(), behavior: 'smooth' }));
  if (aR) aR.addEventListener('click', () => scroll.scrollBy({ left: step(), behavior: 'smooth' }));
  function syncArrows() {
    const max = scroll.scrollWidth - scroll.clientWidth - 2;
    if (aL) aL.classList.toggle('off', scroll.scrollLeft <= 2);
    if (aR) aR.classList.toggle('off', scroll.scrollLeft >= max);
  }
  scroll.addEventListener('scroll', () => { syncArrows(); closePop(); });
  window.addEventListener('resize', () => { syncArrows(); closePop(); });
  setTimeout(syncArrows, 60);

  scroll.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    down = true; sx = e.clientX; sl = scroll.scrollLeft; scroll.classList.add('is-grab'); track.dataset.dragged = '0'; closePop();
  });
  scroll.addEventListener('pointermove', function (e) {
    if (!down) return;
    const dx = e.clientX - sx; scroll.scrollLeft = sl - dx;
    if (Math.abs(dx) > 6) track.dataset.dragged = '1';
    e.preventDefault();
  });
  function endDrag() { if (!down) return; down = false; scroll.classList.remove('is-grab'); setTimeout(() => track.dataset.dragged = '0', 40); }
  scroll.addEventListener('pointerup', endDrag);
  scroll.addEventListener('pointerleave', endDrag);
})();

/* ---------- Scroll reveals ---------- */
(function () {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => io.observe(el));
})();


/* ---------- Header: drawer, search bar, footer accordions ---------- */
(function () {
  const body = document.body;
  const opener = document.querySelector('[data-drawer-open]');
  if (opener) opener.addEventListener('click', () => body.classList.add('drawer-open'));
  document.querySelectorAll('[data-drawer-close]').forEach(c =>
    c.addEventListener('click', () => body.classList.remove('drawer-open')));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') body.classList.remove('drawer-open'); });
  document.querySelectorAll('[data-drawer-acc]').forEach(btn =>
    btn.addEventListener('click', () => btn.closest('.drawer-item').classList.toggle('open')));
  const st = document.querySelector('[data-search-toggle]');
  const sb = document.getElementById('preetSearchBar');
  if (st && sb) st.addEventListener('click', function (e) {
    e.preventDefault();
    sb.classList.toggle('open');
    if (sb.classList.contains('open')) { const i = sb.querySelector('input'); if (i) i.focus(); }
  });
  document.querySelectorAll('.footer-col .f-toggle').forEach(t =>
    t.addEventListener('click', () => t.closest('.footer-col').classList.toggle('open')));
})();

/* ---------- Product page: gallery, quantity, accordions, AJAX add ---------- */
(function () {
  const wrap = document.querySelector('[data-product]');
  if (!wrap) return;
  const main = wrap.querySelector('[data-pd-main]');
  wrap.querySelectorAll('.pd-thumb').forEach(t => t.addEventListener('click', function () {
    wrap.querySelectorAll('.pd-thumb').forEach(x => x.classList.remove('on'));
    t.classList.add('on');
    if (main && t.dataset.full) main.src = t.dataset.full;
  }));
  const qty = wrap.querySelector('[data-qty]');
  wrap.querySelectorAll('[data-qty-minus]').forEach(b => b.addEventListener('click',
    () => { qty.value = Math.max(1, (parseInt(qty.value) || 1) - 1); }));
  wrap.querySelectorAll('[data-qty-plus]').forEach(b => b.addEventListener('click',
    () => { qty.value = (parseInt(qty.value) || 1) + 1; }));
  wrap.querySelectorAll('.pd-acc > button').forEach(b =>
    b.addEventListener('click', () => b.parentNode.classList.toggle('open')));

  const form = wrap.querySelector('form[data-pd-form]');
  if (form) form.addEventListener('submit', async function (e) {
    e.preventDefault();
    const btn = form.querySelector('.pd-add');
    if (!btn || btn.disabled) return;
    const original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('add failed');
      btn.textContent = 'Added ✓';
      try {
        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.zero = cart.item_count === 0 ? 'true' : 'false'; });
      } catch (_) {}
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    } catch (err) { btn.textContent = 'Try again'; }
    setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 1800);
  });
})();


/* ---------- AJAX add-to-cart for product cards & product page ----------
   Progressive enhancement over the native POST /cart/add forms. If fetch is
   unavailable or the network fails, the form falls back to its normal submit,
   so nothing breaks with JS off. Updates every [data-cart-count] bubble. */
(function () {
  if (!window.fetch) return;

  async function refreshCartCount() {
    try {
      const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.dataset.zero = cart.item_count === 0 ? 'true' : 'false';
      });
      return cart;
    } catch (e) { return null; }
  }

  function buttonFor(form) {
    return form.querySelector('.pxp-add, .preet-card-add, [type="submit"]');
  }
  function labelTarget(btn) {
    return btn && (btn.querySelector('[data-pxp-add-label]') || btn);
  }
  function flash(btn, text, revert, ms) {
    const target = labelTarget(btn);
    if (!target) return;
    target.textContent = text;
    if (revert != null) setTimeout(() => { target.textContent = revert; if (btn) btn.disabled = false; }, ms || 1600);
  }

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest && e.target.closest('form.preet-card-add-form, form.pxp-form');
    if (!form) return;
    if (form.dataset.preetAdding === '1') { e.preventDefault(); return; }

    e.preventDefault();
    const btn = buttonFor(form);
    if (btn && btn.disabled) return;
    const original = labelTarget(btn) ? labelTarget(btn).textContent : '';
    form.dataset.preetAdding = '1';
    if (btn) btn.disabled = true;
    flash(btn, 'Adding…');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      });
      if (res.ok) {
        await refreshCartCount();
        flash(btn, 'Added ✓', original, 1700);
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      } else {
        let message = 'Try again';
        try { const data = await res.json(); if (data && data.description) message = 'Unavailable'; } catch (_) {}
        flash(btn, message, original, 2200);
      }
    } catch (err) {
      /* Network failure — fall back to the form's native submit so the add
         still happens through Shopify's standard /cart/add flow. */
      form.dataset.preetAdding = '';
      if (btn) btn.disabled = false;
      flash(btn, original);
      HTMLFormElement.prototype.submit.call(form);
      return;
    }
    form.dataset.preetAdding = '';
  }, false);
})();

/* Horizontal Staff Picks / Product Showcase rails — Phase 4.4
   Supports arrows, trackpads, mouse dragging, and horizontal finger swiping. */
(function(){
  function initShowcaseRail(scope){
    (scope || document).querySelectorAll('[data-showcase-rail]').forEach(function(rail){
      if(rail.dataset.preetRailReady === '1') return;
      rail.dataset.preetRailReady = '1';

      var section = rail.closest('.showcase');
      if(!section) return;

      var prev = section.querySelector('[data-showcase-prev]');
      var next = section.querySelector('[data-showcase-next]');
      var pointerDown = false;
      var horizontalIntent = false;
      var dragged = false;
      var suppressClick = false;
      var startX = 0;
      var startY = 0;
      var startLeft = 0;
      var activePointerId = null;

      function step(){
        var card = rail.querySelector('.product-card');
        if(!card) return Math.max(260, rail.clientWidth * .8);
        var styles = getComputedStyle(rail);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function sync(){
        var max = Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
        var scrollable = max > 2;
        section.classList.toggle('showcase--scrollable', scrollable);
        rail.setAttribute('aria-roledescription', scrollable ? 'scrollable product carousel' : 'product list');
        if(prev) prev.disabled = !scrollable || rail.scrollLeft <= 2;
        if(next) next.disabled = !scrollable || rail.scrollLeft >= max;
      }

      function scrollByCard(direction){
        rail.scrollBy({ left: step() * direction, behavior: 'smooth' });
      }

      if(prev) prev.addEventListener('click', function(){ scrollByCard(-1); });
      if(next) next.addEventListener('click', function(){ scrollByCard(1); });

      rail.addEventListener('scroll', sync, { passive: true });

      rail.addEventListener('keydown', function(e){
        if(e.key === 'ArrowLeft'){
          e.preventDefault();
          scrollByCard(-1);
        }
        if(e.key === 'ArrowRight'){
          e.preventDefault();
          scrollByCard(1);
        }
      });

      /* Prevent the browser's native image drag from fighting the rail drag. */
      rail.addEventListener('dragstart', function(e){
        if(e.target.closest('img, a')) e.preventDefault();
      });

      rail.addEventListener('pointerdown', function(e){
        if(e.pointerType === 'mouse' && e.button !== 0) return;

        pointerDown = true;
        horizontalIntent = e.pointerType === 'mouse';
        dragged = false;
        suppressClick = false;
        startX = e.clientX;
        startY = e.clientY;
        startLeft = rail.scrollLeft;
        activePointerId = e.pointerId;

        if(e.pointerType === 'mouse'){
          rail.classList.add('is-dragging');
          try { rail.setPointerCapture(e.pointerId); } catch(err) {}
        }
      });

      rail.addEventListener('pointermove', function(e){
        if(!pointerDown || e.pointerId !== activePointerId) return;

        var deltaX = e.clientX - startX;
        var deltaY = e.clientY - startY;

        if(e.pointerType !== 'mouse' && !horizontalIntent){
          /* Keep normal page scrolling when the gesture is primarily vertical. */
          if(Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 7){
            pointerDown = false;
            activePointerId = null;
            return;
          }

          if(Math.abs(deltaX) > 7 && Math.abs(deltaX) >= Math.abs(deltaY)){
            horizontalIntent = true;
            rail.classList.add('is-dragging');
            try { rail.setPointerCapture(e.pointerId); } catch(err) {}
          }
        }

        if(!horizontalIntent) return;

        if(Math.abs(deltaX) > 5){
          dragged = true;
          suppressClick = true;
        }

        rail.scrollLeft = startLeft - deltaX;
        e.preventDefault();
      });

      function endDrag(e){
        if(!pointerDown && !horizontalIntent) return;

        pointerDown = false;
        horizontalIntent = false;
        rail.classList.remove('is-dragging');

        if(activePointerId !== null){
          try { rail.releasePointerCapture(activePointerId); } catch(err) {}
        }
        activePointerId = null;

        /* Snap to the nearest card after a direct drag or swipe. */
        if(dragged){
          var cardStep = step();
          if(cardStep > 0){
            var destination = Math.round(rail.scrollLeft / cardStep) * cardStep;
            rail.scrollTo({ left: destination, behavior: 'smooth' });
          }
        }

        window.setTimeout(function(){
          dragged = false;
          suppressClick = false;
        }, 180);
      }

      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('lostpointercapture', function(e){
        if(e.pointerId === activePointerId) endDrag(e);
      });

      rail.addEventListener('click', function(e){
        if(suppressClick){
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      /* Trackpads keep their native horizontal movement. Shift + mouse wheel
         also moves the rail horizontally without requiring the arrows. */
      rail.addEventListener('wheel', function(e){
        var horizontalDelta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : 0;
        if(e.shiftKey && !horizontalDelta) horizontalDelta = e.deltaY;
        if(!horizontalDelta) return;

        var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        var canMove = (horizontalDelta < 0 && rail.scrollLeft > 0) ||
                      (horizontalDelta > 0 && rail.scrollLeft < max);
        if(!canMove) return;

        rail.scrollLeft += horizontalDelta;
        e.preventDefault();
      }, { passive: false });

      if('ResizeObserver' in window){
        new ResizeObserver(sync).observe(rail);
      } else {
        window.addEventListener('resize', sync);
      }

      requestAnimationFrame(sync);
      setTimeout(sync, 250);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initShowcaseRail(document); });
  } else {
    initShowcaseRail(document);
  }

  document.addEventListener('shopify:section:load', function(e){
    initShowcaseRail(e.target);
  });
})();
